import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiPasswordTypeToggleComponent } from '@components/ui-password-toggle/ui-password-toggle.component';
import { MatTooltipModule } from '@directives/ui-tooltip';

@NgModule({
    imports: [
        ComponentSharedModule,
        MatTooltipModule,
        MatIconModule,
        MatButtonModule,
    ],
    declarations: [
        UiPasswordTypeToggleComponent,
    ],
    exports: [
        UiPasswordTypeToggleComponent,
    ],
})
export class UiPasswordTypeToggleModule { }
